<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card v-if="data">
            <v-form
                ref="form"
                @submit.prevent="handleUpdateGroup"
            >
                <v-card-title style="background-color: #009688; color: white; word-break: break-word;">
                    Edit Group: {{ data.MSUGRP_NAME }}
                </v-card-title>
                <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                    <v-text-field
                        v-model="newName"
                        style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                        label="Group Name"
                        :rules="[v=>!!v||'This field is required']"
                        clearable
                    />
                </v-card-text>
                <v-card-actions style="background-color: #EDFFFB;">
                    <v-spacer />
                    <v-btn
                        outlined
                        class="white--text"
                        color="teal darken-1"
                        style="width: 105px;"
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1 white--text"
                        class="white--text"
                        style="width: 105px; font-weight: 600"
                        :loading="loading"
                        type="submit"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        loading: false,
        newName: null
    }),
    computed: {
        ...mapGetters(['editMsuGroupNameData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        editMsuGroupNameData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Group has been updated.'
                    this.notif.show = true
                    this.showDialog = false
                    this.listMsuGroups()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        show(newVal) {
            if(newVal) {
                this.newName = this.data.MSUGRP_NAME
            }
        }
    },
    created() {
        // this.getCsrfToken()
    },
    methods: {
        ...mapActions(['getCsrfToken', 'editMsuGroupName', 'listMsuGroups']),
        handleUpdateGroup() {
            if (this.$refs && this.$refs.form.validate()) {
                this.loading = false
                this.editMsuGroupName({ 'MSUGRP_ID': this.data.MSUGRP_ID, 'MSUGRP_NAME': this.newName })
            }
        }
    }
}
</script>
